import React from 'react'
import IconBase from './IconBase'

const Warning = props => (
  <IconBase viewBox="0 0 35 30" {...props}>
        <g>
            <path d="M34.653,30.47L18.727,2.884c-0.269-0.464-0.764-0.75-1.299-0.75c-0.537,0-1.031,0.286-1.3,0.75L0.202,30.47
                c-0.269,0.464-0.269,1.036,0,1.5s0.763,0.75,1.299,0.75h31.853c0.535,0,1.031-0.286,1.3-0.75
                C34.921,31.506,34.921,30.934,34.653,30.47z M4.099,29.72L17.427,6.634L30.756,29.72H4.099z M15.427,11.677h4V23.51h-4V11.677z
                M15.427,25.507h4v2.919h-4V25.507z"/>
        </g>
  </IconBase>
)

export default Warning
